/**
 * Status configuration for Faraid cases
 * Maps case statuses to badge variants and allowed actions per role
 */

// Status → IntercomBadge variant mapping
export const statusVariants = {
  submitted: 'info',
  under_review: 'warning',
  info_requested: 'warning',
  info_provided: 'info',
  evaluated: 'success',
  delivered: 'success',
  disputed: 'error',
  re_evaluated: 'success',
  cancelled: 'default',
  auto_closed: 'default',
  archived: 'default',
}

// Status → i18n label key
export const statusLabelKeys = {
  submitted: 'status.submitted',
  under_review: 'status.underReview',
  info_requested: 'status.infoRequested',
  info_provided: 'status.infoProvided',
  evaluated: 'status.evaluated',
  delivered: 'status.delivered',
  disputed: 'status.disputed',
  re_evaluated: 'status.reEvaluated',
  cancelled: 'status.cancelled',
  auto_closed: 'status.autoClosed',
  archived: 'status.archived',
}

// Actions available to case owner (user) per status
export const userActions = {
  submitted: ['cancel'],
  under_review: ['cancel'],
  info_requested: ['respond', 'cancel'],
  info_provided: [],
  evaluated: ['dispute'],
  delivered: ['dispute'],
  disputed: [],
  re_evaluated: ['dispute'],
  cancelled: [],
  auto_closed: [],
  archived: [],
}

// Actions available to scholar per status
export const scholarActions = {
  submitted: ['pickup'],
  under_review: ['approve', 'adjust', 'override', 'request_info'],
  info_requested: [],
  info_provided: ['approve', 'adjust', 'override', 'request_info'],
  evaluated: ['deliver', 're_evaluate'],
  delivered: [],
  disputed: ['re_evaluate'],
  re_evaluated: ['deliver'],
  cancelled: [],
  auto_closed: [],
  archived: [],
}
